import i from 'i18next'
import { useRouter } from 'next/router'
import { ProductDetail } from 'lib/hooks/use-products'
import { Rating } from 'lib/hooks/use-reviews'

type Props = {
	product: ProductDetail
	rating: Rating
}

export default function Json({ product, rating }: Props ) {
	const { asPath } = useRouter()
	const json = {
		'@context': 'http://schema.org/',
		'@type': 'Product',
		'name': i.t( 'product.title', { product: product.title }),
		'url': `https://ray.care${asPath}`,
		'image': [
			product.images?.[ 1 ] && product.images[ 1 ].originalSrc,
			product.images?.[ 2 ] && product.images[ 2 ].originalSrc,
		].filter( Boolean ),
		'description': i.t( [
			`product.description.${product.handle}`,
			product.description,
		] ),
		'brand': {
			'@type': 'Organization',
			'name': 'Ray Hair \u0026 Body Care',
		},
		'offers': {
			'@type': 'AggregateOffer',
			// eslint-disable-next-line max-len
			'highPrice': Math.max( ...product.variants.map( variant => +variant.priceV2.amount ) ),
			// eslint-disable-next-line max-len
			'lowPrice': Math.min( ...product.variants.map( variant => +variant.priceV2.amount ) ),
			'priceCurrency': 'EUR',
		},
		'variants': product.variants.map( variant => ({
			'@type': 'Offer',
			'availability': ( variant.availableForSale
				? 'http://schema.org/InStock'
				: 'http://schema.org/OutOfStock'
			),
			'price': variant.priceV2.amount,
			'priceCurrency': 'EUR',
			'url': `https://ray.care${asPath}?variant=${variant.id}`,
		}) ),
		'aggregateRating': {
			'@type': 'AggregateRating',
			'ratingValue': rating.average,
			'reviewCount': rating.num,
			'bestRating': 5,
			'worstRating': 1,
		},
	}

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify( json ) }}
		/>
	)
}
